let state = {
    SICSEN_Catalogos_003TiposResoluciones: {},
    SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado: moment().format('YYYY-MM-DD'),
    SICSEN_Sentencias_FiltroBusqueda_FechaDeSentencia: moment().format('YYYY-MM-DD'),
    SICSEN_Sentencias_FiltroBusqueda_FolioSentencia:-1,
    SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal: "",
    SICSEN_Sentencias_InformacionSentencia_RutaArchivoOrigen: "",
    SICSEN_Sentencias_InformacionSentencia_RutaWordTestado: "",
    SICSEN_Sentencias_InformacionSentencia_Archivo:null,
    SICSEN_Sentencias_InformacionSentencia_Sentencia:null,
    SICSEN_Sentencias_EsBase64: {},
}

let getters = {
    Get_SICSEN_Catalogos_003TiposResoluciones: state => {
        return state.SICSEN_Catalogos_003TiposResoluciones;
    },
    Get_SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado: state => {
        return state.SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado;
    },
    Get_SICSEN_Sentencias_FiltroBusqueda_FechaDeSentencia: state => {
        return state.SICSEN_Sentencias_FiltroBusqueda_FechaDeSentencia;
    },
    Get_SICSEN_Sentencias_FiltroBusqueda_FolioSentencia: state => {
        return state.SICSEN_Sentencias_FiltroBusqueda_FolioSentencia;
    },
    Get_SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal: state => {
        return state.SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal;
    },
    Get_SICSEN_Sentencias_InformacionSentencia_RutaArchivoOrigen: state => {
        return state.SICSEN_Sentencias_InformacionSentencia_RutaArchivoOrigen;
    },
    Get_SICSEN_Sentencias_InformacionSentencia_RutaWordTestado: state => {
        return state.SICSEN_Sentencias_InformacionSentencia_RutaWordTestado;
    },
    Get_SICSEN_Sentencias_InformacionSentencia_Archivo: state => {
        return state.SICSEN_Sentencias_InformacionSentencia_Archivo;
    },
    Get_SICSEN_Sentencias_InformacionSentencia_Sentencia: state => {
        return state.SICSEN_Sentencias_InformacionSentencia_Sentencia;
    },
    Get_SICSEN_Sentencias_EsBase64: state => {
        return state.SICSEN_Sentencias_EsBase64;
    }
}

let mutations = {
    M_SICSEN_Catalogos_003TiposResoluciones(state, data) {
        state.SICSEN_Catalogos_003TiposResoluciones[data.llave] = data.valor;
    },
    M_SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado(state, data) {
        state.SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado = data;
    },
    M_SICSEN_Sentencias_FiltroBusqueda_FechaDeSentencia(state, data) {
        state.SICSEN_Sentencias_FiltroBusqueda_FechaDeSentencia = data;
    },
    M_SICSEN_Sentencias_FiltroBusqueda_FolioSentencia(state, data) {
        state.SICSEN_Sentencias_FiltroBusqueda_FolioSentencia = data;
    },
    M_SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal(state,data){
        state.SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal = data;
    },
    M_SICSEN_Sentencias_InformacionSentencia_RutaArchivoOrigen(state,data){
        state.SICSEN_Sentencias_InformacionSentencia_RutaArchivoOrigen = data;
    },
    M_SICSEN_Sentencias_InformacionSentencia_RutaWordTestado(state,data){
        state.SICSEN_Sentencias_InformacionSentencia_RutaWordTestado = data;
    },
    M_SICSEN_Sentencias_InformacionSentencia_Archivo(state,data){
        state.SICSEN_Sentencias_InformacionSentencia_Archivo = data;
    },
    M_SICSEN_Sentencias_InformacionSentencia_Sentencia(state,data){
        state.SICSEN_Sentencias_InformacionSentencia_Sentencia = data;
    },
    M_SICSEN_Sentencias_EsBase64(state,data){
        state.SICSEN_Sentencias_EsBase64 = data;
    }
}

let actions = {
    A_SICSEN_Catalogos_003TiposResoluciones: ({ commit }, data) => {
        commit('M_SICSEN_Catalogos_003TiposResoluciones', data)
    },
    A_SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado: ({ commit }, data) => {
        commit('M_SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado', data)
    },
    A_SICSEN_Sentencias_FiltroBusqueda_FechaDeSentencia: ({ commit }, data) => {
        commit('M_SICSEN_Sentencias_FiltroBusqueda_FechaDeSentencia', data)
    },
    A_SICSEN_Sentencias_FiltroBusqueda_FolioSentencia: ({ commit }, data) => {
        commit('M_SICSEN_Sentencias_FiltroBusqueda_FolioSentencia', data)
    },
    A_SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal: ({ commit }, data) => {
        commit('M_SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal', data)
    },
    A_SICSEN_Sentencias_InformacionSentencia_RutaArchivoOrigen: ({ commit }, data) => {
        commit('M_SICSEN_Sentencias_InformacionSentencia_RutaArchivoOrigen', data)
    },
    A_SICSEN_Sentencias_InformacionSentencia_RutaWordTestado: ({ commit }, data) => {
        commit('M_SICSEN_Sentencias_InformacionSentencia_RutaWordTestado', data)
    },
    A_SICSEN_Sentencias_InformacionSentencia_Archivo: ({ commit }, data) => {
        commit('M_SICSEN_Sentencias_InformacionSentencia_Archivo', data)
    },
    A_SICSEN_Sentencias_InformacionSentencia_Sentencia: ({ commit }, data) => {
        commit('SICSEN_Sentencias_InformacionSentencia_Sentencia', data)
    },
    A_SICSEN_Sentencias_EsBase64: ({ commit }, data) => {
        commit('M_SICSEN_Sentencias_EsBase64', data)
    }
}

const SICSEN = {
    State: state,
    Getters: getters,
    Mutations: mutations,
    Actions: actions
}
export default SICSEN;



// WEBPACK FOOTER //
// ./src/store/SICSEN.js